import {analyticsLogger} from './analyticsLogger';

export type DcdOwnershipPageType = 'app' | 'component' | 'service' | 'service_route' | 'code_path';

export type DcdOwnershipBreadcrumbType =
  | 'apps'
  | 'teams'
  | 'components_and_services'
  | DcdOwnershipPageType;

export type DcdOwnershipDetailInteractionAction =
  | 'breadcrumb_clicked'
  | 'metadata_chip_clicked'
  | 'oncall_clicked'
  | 'owner_clicked'
  | 'service_clicked';

export type DcdOwnershipServiceGraphInteractionAction =
  | 'graph_expanded'
  | 'graph_collapsed'
  | 'node_clicked'
  | 'node_expanded'
  | 'node_collapsed'
  | 'open_link_clicked'
  | 'node_view_more';

export type DcdOwnershipServiceGraphNodeType =
  | 'grouper'
  | 'component'
  | 'service'
  | 'service_route'
  | 'code_path';

export type DcdOwnershipSearchOutcome = 'result_selected' | 'no_results' | 'abandoned';
export type DcdOwnershipSearchSurface = 'apps' | 'components_and_services';

export const logDcdOwnershipLeftNavResultSelectedWithoutSearch = ({
  searchSurface,
  resultCount,
  resultType,
  rank,
}: {
  searchSurface: DcdOwnershipSearchSurface;
  resultCount: number;
  resultType: string;
  rank: number;
}) => {
  analyticsLogger().logEvent('DCD_OWNERSHIP_LEFT_NAV_RESULT_SELECTED_WITHOUT_SEARCH', {
    search_surface: searchSurface,
    result_count: resultCount,
    result_type: resultType,
    rank,
  });
};

export const logDcdOwnershipSearchOutcome = ({
  outcome,
  searchSurface,
  useServerSearch,
  resultCount,
  resultType,
  rank,
}: {
  outcome: DcdOwnershipSearchOutcome;
  searchSurface: DcdOwnershipSearchSurface;
  useServerSearch: boolean;
  resultCount: number;
  resultType?: string;
  rank?: number;
}) => {
  analyticsLogger().logEvent('DCD_OWNERSHIP_SEARCH_OUTCOME', {
    outcome,
    search_surface: searchSurface,
    search_mode: useServerSearch ? 'server' : 'client',
    result_count: resultCount,
    ...(resultType ? {result_type: resultType} : {}),
    ...(rank !== undefined ? {rank} : {}),
  });
};

export const logDcdOwnershipDetailInteraction = (
  action: DcdOwnershipDetailInteractionAction,
  {
    pageType,
    breadcrumbType,
    chipType,
  }: {
    pageType: DcdOwnershipPageType;
    breadcrumbType?: DcdOwnershipBreadcrumbType;
    chipType?: string;
  }
) => {
  analyticsLogger().logEvent('DCD_OWNERSHIP_DETAIL_INTERACTION', {
    action,
    page_type: pageType,
    ...(breadcrumbType ? {breadcrumb_type: breadcrumbType} : {}),
    ...(chipType ? {chip_type: chipType} : {}),
  });
};

export const logDcdOwnershipServiceGraphInteraction = (
  action: DcdOwnershipServiceGraphInteractionAction,
  {
    isGraphFullscreen,
    nodeType,
  }: {
    isGraphFullscreen?: boolean;
    nodeType?: DcdOwnershipServiceGraphNodeType;
  } = {}
) => {
  analyticsLogger().logEvent('DCD_OWNERSHIP_SERVICE_GRAPH_INTERACTION', {
    action,
    ...(isGraphFullscreen !== undefined ? {is_graph_fullscreen: isGraphFullscreen} : {}),
    ...(nodeType ? {node_type: nodeType} : {}),
  });
};
